export const themeSliceName = 'Theme';
